<template>
  <el-dialog :title="dialogTitle" :visible.sync="editRecordVisible">
    <span class="fk-tips">以下至少选一种填写</span>
    <el-form
      :model="recordForm"
      ref="recordForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="反馈内容" prop="tips">
        <el-input v-model="recordForm.tips" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="反馈图片" prop="imgPaths">
        <el-upload
          ref="imgUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :limit="6"
          :data="uploadData"
          :on-exceed="uploadImgExceed"
          :before-upload="uploadImgBefore"
          list-type="picture-card"
          multiple
          :accept="'image/*'"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">支持jpg,jpeg,bmp,gif,png格式照片,大小不超过8M,最多上传9张图片</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="反馈视频" prop="videoPaths">
        <el-upload
          ref="videoUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :before-upload="uploadVideoBefore"
          :on-success="videoPathsSuccess"
          :show-file-list="false"
          :data="uploadData"
          list-type="picture-card"
          :accept="'video/*'"
        >
          <video
            style="float:left;"
            width="125px"
            height="125px"
            v-if="recordForm.videoPaths"
            :src="recordForm.videoPaths|getBaseImgUrl"
            controls="controls"
          >您的浏览器不支持视频播放</video>
          <i class="el-icon-plus" v-else></i>
          <div slot="tip" class="el-upload__tip">支持mp4,avi格式视频,大小不超过100M,最多上传1个视频</div>
        </el-upload>
      </el-form-item>
      <!-- 暂时屏蔽PC端建议 -->
       <!-- <el-form-item
          label="建议类型"
          label-width="110px"
          prop="applyRes"
        >
          <el-select
            ref="handleTypeName"
            v-model="recordForm.handleTypeName"
            placeholder="请选择建议类型"
            class="el-select--maia"
            clearable
            @change="selectReason"
          >
            <el-option
              v-for="item in handleResList"
              :key="item.code"
              :label="item.name"
              :value="{label:item.name,value:item.code}"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="recordForm.handleType==='qt'"
          class="width-484 mt-24 con-left0"
          label="处理建议"
          label-width="110px"
        >
          <el-input
            v-model="recordForm.handleAdvise"
            type="textarea"
            size="medium"
            maxlength="200"
            placeholder="请输入处理建议"
            clearable
          />
        </el-form-item> -->

    </el-form>
    <span slot="footer" class="dialog-footer" style="text-align:center">
      <el-button type="primary" v-no-more-click @click="save(1)" >提交</el-button>
      <el-button type="primary" v-no-more-click @click="save(2)" >提交并继续</el-button>
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { insertrecord } from "@/api/admin/taskManagement";
import { objKeySort } from "@/util/ajaxsign";
import { apiLink, getImgLink } from "@/config/env";
import {
  getDictList
} from "@/api/admin/dict";
export default {
  name: "editRecord",
  data() {
    return {
      isSaveBtn:false,
      editRecordVisible: false,
      dialogTitle: "添加反馈",
      uploadData: {},
      recordForm: {
        projectId: "",
        type: 2,
        tips: "",
        imgPaths: "",
        videoPaths: "",
        voicePaths:"",
        handleAdvise:'',
        handleType:'',
        handleAdvise:''
      },
      rules: {
        tips: [{ required: true, message: "请填写工作内容", trigger: "blur" }]
      },
      projectId: "",
      handleResList:[],
    };
  },

  created() {
    this.uploadData = objKeySort({});
    this.init()
  },
  filters: {
    getBaseApiUrl: function(uri) {
      if (uri) {
        return apiLink(uri);
      } else {
        return "";
      }
    },
    getBaseImgUrl: function(uri) {
      console.log(uri);
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    }
  },
  methods: {
    init(){
       let that=this
        getDictList(objKeySort({
          code: "handle_type"
        })).then(res => {
          console.log('res',res);
          res.data.data.handle_type.forEach(i=>{
            i.checked=false
          })
          that.handleResList=res.data.data.handle_type
        });
    },
    selectReason(obj){
      if(obj){
        this.recordForm.handleType= obj.value
        this.recordForm.handleTypeName= obj.label
      }else{
        this.recordForm.handleType= ''
        this.recordForm.handleTypeName= ''
      }
    },
    //设置展示
    uploadImgBefore(file) {
      let isImg = false;
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/bmp" ||
        file.type == "image/jpg" ||
        file.type == "image/gif"
      ) {
        isImg = true;
      }
      const isLt8M = file.size / 1024 / 1024 < 8;
      if (!isImg) {
        this.$message.error("上传图片只能是jpg,jpeg,bmp,gif,png格式照片!");
      }
      if (!isLt8M) {
        this.$message.error("上传图片大小不能超过 8MB!");
      }
      return isImg && isLt8M;
    },
    uploadVideoBefore(file) {
      let isVideo = false;
      if (file.type == "video/mp4" || file.type == "video/avi") {
        isVideo = true;
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isVideo) {
        this.$message.error("上传视频只能是MP4,AVI格式视频文件!");
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过 100MB!");
      }
      return isVideo && isLt100M;
    },

    //文件变化
    videoPathsSuccess(res) {
      this.recordForm.videoPaths = "";
      if (res.data && res.data.filePath) {
        this.recordForm.videoPaths = res.data.filePath;
      }
    },
    uploadImgExceed(files, fileList) {
      this.$message.warning(
        `照片最多只能上传6张`
      );
    },
    uploadVideoExceed(files, fileList) {
      this.$message.warning(
        `视频最多只能上传3个`
      );
    },
    setProjectId(projectId,type) {
      this.cleanForm();
      this.recordForm.projectId = projectId;
      this.recordForm.type = type;
      this.projectId=projectId;
      this.editRecordVisible = true;
      if(type==1){
        this.dialogTitle = "添加日志反馈";
      }else{
        this.dialogTitle = "添加问题反馈";
      }
    },
    save(type) {
      let that=this
      if(that.recordForm.handleType=='qt'&&that.recordForm.handleAdvise==''){
        that.$message.error('请输入建议内容')
        return
      }

      that.$refs.recordForm.validate(valid => {
        if (valid) {
          that.isSaveBtn = true;
          that.initContentImg();
          insertrecord(objKeySort(that.recordForm)).then(response => {
            if (response.data.code == 200) {
              that.$emit("refreshcord");
              if (type == 1) {
                that.close();
              } else {
                that.setProjectId(that.projectId,this.recordForm.type);
              }
            } else {
              that.$message.error("反馈添加失败:" + response.data.msg);
            }
            that.isSaveBtn = false;
          });
        } else {
          return false;
        }
      });
    },
    initContentImg() {
      const fileList = this.$refs.imgUpload.uploadFiles;
      this.recordForm.imgPaths = "";
      if (fileList && fileList.length > 0) {
        fileList.forEach(f => {
          if ((f.response && f.response.data.filePath) || f.url) {
            if (this.recordForm.imgPaths) {
              this.recordForm.imgPaths = this.recordForm.imgPaths + ",";
            }
            this.recordForm.imgPaths =
              this.recordForm.imgPaths +
              (f.response ? f.response.data.filePath : f.url).replace(
                new RegExp(getImgLink(""), "g"),
                ""
              );
          }
        });
      }
      // const imgUrl = getImgLink("");
      // console.log(imgUrl);
      // this.recordForm.imgPaths = this.recordForm.imgPaths.replace(new RegExp(imgUrl,'g'),"");
      console.log(fileList, this.recordForm);
    },
    close() {
      this.editRecordVisible = false;
      this.cleanForm();
    },
    cleanForm() {
      if (this.$refs.recordForm) {
        this.$refs.recordForm.clearValidate();
        this.$refs.imgUpload.clearFiles();
        this.$refs.videoUpload.clearFiles();
      }
      this.recordForm = {
        projectId: "",
        type: 2,
        tips: "",
        imgPaths: "",
        videoPaths: "",
        voicePaths:"",
        handleType:'',
        handleTypeName:'',
        handleAdvise:''
      };
    }
  }
};
</script>
<style lang="scss" scoped>
  .fk-tips{
    font-size: 14px;
    color: #C0C4CC;
    position: absolute;
    top: 20px;
    left: 160px;
  }
  .avue-crud-upload ul li {
    width: 90px;
    float: left;
    margin: 0 15px 15px 0;
  }
</style>
